import { Pencil, PlusCircle } from "lucide-react";
import React from "react";

function FormHeading({ formType, title, subtitle }) {
  return (
    <div className="flex items-center justify-between bg-gradient-to-r from-slate-50 to-white py-2 rounded-xl px-6 shadow-sm">
      <div className="flex items-center gap-4">
        <div
          className={`flex items-center justify-center w-12 h-12 rounded-xl shadow-sm
      ${
        formType === "create"
          ? "bg-blue-100 border border-blue-400 text-blue-600"
          : "bg-amber-100 border border-yellow-400 text-amber-600"
      }`}
        >
          {formType === "create" ? (
            <PlusCircle className="w-6 h-6" />
          ) : (
            <Pencil className="w-6 h-6" />
          )}
        </div>

        <div className="flex flex-col">
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900">
            {title}
          </h1>
          <p className="text-sm text-slate-500">{subtitle}</p>
        </div>
      </div>

      <span
        className={`px-3 py-1 text-xs font-semibold rounded-full
      ${
        formType === "create"
          ? "bg-blue-50 text-blue-600 border border-blue-200"
          : "bg-amber-50 text-amber-600 border border-amber-200"
      }`}
      >
        {formType === "create" ? "NEW" : "EDIT MODE"}
      </span>
    </div>
  );
}

export default FormHeading;
